"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _StyledLink = _interopRequireDefault(require("./StyledLink"));

var _TopicImage = _interopRequireDefault(require("./TopicImage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var IconListItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconListItem, _React$PureComponent);

  function IconListItem() {
    _classCallCheck(this, IconListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconListItem).apply(this, arguments));
  }

  _createClass(IconListItem, [{
    key: "render",
    value: function render() {
      var item = this.props.item;
      var content = '';
      ;

      if (item.icon) {
        // Image provided as a url.
        content = _react["default"].createElement(_StyledLink["default"], {
          href: item.ref
        }, _react["default"].createElement("img", {
          src: item.icon,
          alt: item.alt
        }), _react["default"].createElement("div", null, item.title));
      } else {
        // Image provided by custom component.
        content = _react["default"].createElement(_StyledLink["default"], {
          href: item.ref
        }, _react["default"].createElement(_TopicImage["default"], {
          title: item.title,
          width: "80",
          height: "80",
          fill: item.color,
          alt: this.props.alt
        }), _react["default"].createElement("div", null, item.title));
      }

      ;
      return _react["default"].createElement("li", {
        key: item.identifier
      }, content);
    }
  }]);

  return IconListItem;
}(_react["default"].PureComponent);

var _default = IconListItem;
exports["default"] = _default;